import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';
import RelatedDocument from 'types/related-document';

const unlinkOrderOptionDocument = api.injectEndpoints({
  endpoints: builder => ({
    unlinkOrderOptionDocument: builder.mutation<
      Response,
      UnlinkOrderOptionDocumentRequest
    >({
      query: params => {
        return {
          method: 'POST',
          url: `orders/${params.id}/commercial-products/${params.commercial_product_id}/commercial-product-options/${params.option_id}/unlink-order`,
          body: {
            model_id: params.target?.id,
            commercial_product_id: params.target?.commercial_product_id,
            model_type: params.target?.model_type,
            document_type: params.target?.document_type,
            document_class: params.target?.document_class,
          },
        };
      },
      //@ts-expect-error
      invalidatesTags: (result, error, params) => {
        if (result) {
          return [{type: 'orders', id: params.id}];
        }
        return [];
      },
    }),
  }),
});

export type UnlinkOrderOptionDocumentRequest = {
  option_id?: ObjectId;
  commercial_product_id?: ObjectId;
  target?: RelatedDocument;
  id?: ObjectId;
};

type Response = ResponseData<RelatedDocument[]>;

export const {useUnlinkOrderOptionDocumentMutation} = unlinkOrderOptionDocument;

export const unlinkOrderOptionDocumentEndpoint =
  unlinkOrderOptionDocument.endpoints.unlinkOrderOptionDocument;
